import { lazy, Suspense } from "react";
import { GeneralSettingsPanel } from "@cayo/core/components/GeneralSettingsPanel";
import AlertPanel from "@cayo/shared/components/Alerts/AlertPanel";
import CompanyLogo from "@cayo/shared/components/schemes/CompanyLogo";
import HtmlPage from "@cayo/shared/components/schemes/HtmlPage";
import { adminAlertComponents } from "../../../admin-components/alerts";
import StaticAlerts from "../../Alerts/StaticAlerts";
import ComponentStatus from "../../ComponentStatus";
import Nav from "../../Nav/Nav";
import Schedule from "../../Schedule";
import Workflow from "../../Workflow/Workflow";
import NavHeader from "../NavHeader";
import PageContent from "../PageContent";

const Dashboard = lazy(() => import("../../Dashboard"));

const DashboardRenderer = (props: any) => (
  <Suspense fallback={null}>
    <Dashboard {...props} />
  </Suspense>
);

const userControlRenderers = {
  navheader: NavHeader,
  pagecontent: PageContent,
  nav: Nav,
  companylogo: CompanyLogo,
  dashboard: DashboardRenderer,
  staticalerts: StaticAlerts,
  alertpanel: AlertPanel,
  workflow: Workflow,
  componentstatus: ComponentStatus,
  schedule: Schedule,
  ...adminAlertComponents,
  htmlpage: HtmlPage,
  generalsettings: GeneralSettingsPanel,
};

export default userControlRenderers;
